module.exports = __webpack_public_path__ + "media/assets/faria_products/CP-29cc9d45e56f55dfeeca7029edcafd895cda2d728e1611ab00143e107928a391.png";